<div class="mail-body-wrapper" [class.mail-body-fixed]="scrollsInside || measuredHeight === null">
  <p-messages *ngIf="blockedImageCount > 0 && !allowRemoteImages" severity="warn" [closable]="false" styleClass="mail-body-notice">
    <ng-template pTemplate>
      <div class="flex align-items-center justify-content-between w-full gap-2">
        <span>
          Se han bloqueado {{blockedImageCount}} {{blockedImageCount === 1 ? 'imagen externa' : 'imágenes externas'}}.
          Cargarlas avisa al remitente de que has abierto el correo.
        </span>
        <p-button label="Mostrar imágenes" icon="pi pi-image" size="small" [text]="true" (click)="showImages()"></p-button>
      </div>
    </ng-template>
  </p-messages>

  <div class="mail-body-frame-holder">
    <p-progressBar *ngIf="loading" mode="indeterminate" [style]="{height: '3px'}" styleClass="mail-body-progress"></p-progressBar>

    <!-- sandbox SIN allow-scripts: es la garantia que no se puede tocar. allow-same-origin va con srcdoc para poder
         medir el alto del correo y que se vea entero; si algun dia se añade allow-scripts, hay que quitar
         allow-same-origin en el mismo cambio. Ver el comentario del componente. -->
    <iframe #frame
            class="mail-body-frame"
            [style.height.px]="measuredHeight"
            sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            referrerpolicy="no-referrer"
            title="Contenido del mensaje"
            (load)="onFrameLoad()"></iframe>
  </div>
</div>
